import script from "./Customerdetail-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Customerdetail-big.vue?vue&type=script&setup=true&lang=js"

import "./Customerdetail-big.vue?vue&type=style&index=0&id=9c09eeb2&lang=css"

const __exports__ = script;

export default __exports__